import { Typography, VARIANTS } from 'shared';

import {
  ModalBody,
  ModalFooter,
  ModalHeader,
  useModalContext,
} from 'shared/components/Modal';
import { ModalButton } from 'shared/components/Modal/ModalButton';

type PrioritizedGoalLimitReachedProps = {
  onSubmit: () => void;
};

export const GoalPrioritizeLimitReachedModal = ({
  onSubmit,
}: PrioritizedGoalLimitReachedProps) => {
  const { title } = useModalContext() as { title: string };

  return (
    <>
      <ModalHeader>
        <Typography type="heading" fontWeight="semibold" pr={2}>
          {title}
        </Typography>
      </ModalHeader>
      <ModalBody>
        <Typography type="small" fontWeight="regular" color="gray">
          If you want to review goals and decide what goals have more priority,
          please check the priorities below
        </Typography>
      </ModalBody>
      <ModalFooter>
        <ModalButton variant="outline" dataTestid="cancel-modal-btn">
          Cancel
        </ModalButton>
        <ModalButton
          color={VARIANTS.PRIMARY}
          shouldClose={false}
          onClick={onSubmit}
          dataTestid="check-the-priorities-modal-btn"
        >
          Check the priorities
        </ModalButton>
      </ModalFooter>
    </>
  );
};
